import { Modal } from "react-bootstrap";
import { useRecommendation } from "../../../contexts/recommendation-context";
import { AllianceForm } from "./AllianceForm";
import { FyntuneForm } from "./FyntuneForm";
import { PayBimaForm } from "./PayBimaForm";

const FewMoreQuestionsModal = ({
  fewMoreQuestionsModal,
  handleClose,
  sumAssured = 0,
  policyTerm = 0,
}) => {
  const { broker } = useRecommendation();
  return (
    <Modal size="lg" show={fewMoreQuestionsModal} onHide={handleClose}>
      <Modal.Body>
        {["fyntune"].includes(broker) ? (
          <FyntuneForm sumAssured={sumAssured} policyTerm={policyTerm} />
        ) : ["alliance"].includes(broker) ? (
          <AllianceForm sumAssured={sumAssured} policyTerm={policyTerm} />
        ) : (
          <PayBimaForm sumAssured={sumAssured} policyTerm={policyTerm} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export { FewMoreQuestionsModal };
